<script>
    import { keydowns } from '../utils.js';
    import api from '../api';

    let password, username;

    $: valid = password && username;

    async function login() {
        const response = await api.post('login/', { username, password });
        if (!response.status === 200) return;
        const next = new URLSearchParams(window.location.href).get('next');
        document.location = next || '/';
    }
</script>

<div class="fixed top-0 bottom-0 left-0 right-0">
    <div class="flex h-full">
        <div class="flex flex-col p-4 m-auto border rounded shadow-md">
            <div class="mb-3">
                <input placeholder="Usuario" bind:value="{username}" />
            </div>
            <div class="mb-3">
                <input
                    bind:value="{password}"
                    type="password"
                    placeholder="Contraseña"
                    use:keydowns
                    on:keydown.Enter="{valid && login()}"
                />
            </div>
            <button on:click="{login}" disabled="{!valid}">Ingresar</button>
        </div>
    </div>
</div>
